import React, { useEffect } from 'react';
import styled from 'styled-components/macro';
import { IconIcoSearch } from 'Ui/Icons';
import logoBzcPath from 'Assets/images/BzcLogo1.svg';
import HeaderBasket from '../HeaderBasket';
import AnonymousHeader from './AnonymousHeader';
import UiStore from 'Store/UiStore';
import AuthStore from 'Store/AuthStore';
import BannerApp from 'Components/BannerApp';
import { isAndroid, isIOS, isMobile } from 'react-device-detect';
import { storageFactory } from 'Libs/storageFactory';
import BirthdayReminderModal from 'Components/modals/BirthReminderModal';
import {
  dateDiff,
  timestampAndCount,
  createCookieBirtdayReminder,
} from 'Utils/date';
import Cookie from 'js-cookie';
import { theme } from 'Ui';
import IconeMenu from 'Ui/Icons/icons/IconeMenu';
import WishListMenu from '../DesktopHeader/WishListMenu';
import { AccountHeader, CheckMark, LogoMobile } from 'Ui/Icons/icons';
import SearchInput from './SearchInput';
import { LogoTitle } from '../DesktopHeader';
import { DeviceEnum, OsEnum } from '__generated__/graphql-global-types';
import { useQuery } from '@apollo/client';
import { getHeaderNavigation } from '../__generated__/getHeaderNavigation';
import headerNavigationQuery from '../headerNavigationQuery';
const MobileHeaderHeight = 4.8;

const HeaderMobileContainer = styled.div`
  width: 100%;
  padding: 0 1.6rem 0.8rem;
`;

const HeaderNavContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
`;

const HeaderLogoContainer = styled.div`
  /* width: 65%; */
  display: flex;
  /* margin-left: 1.8rem; */
`;

const HeaderMenuContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
`;

const FixBar = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  padding-top: 1.6rem;
  background-color: #fff;
  z-index: 1000;
  box-shadow: 0px 1px 9px 0px rgba(0, 0, 0, 0.1);
  .addShadow {
    box-shadow: 0px 1px 9px 0px rgba(0, 0, 0, 0.1);
  }
`;

const TopBar = styled.div`
  display: flex;
  align-items: center;
  height: ${MobileHeaderHeight}rem;
  justify-content: space-between;
  /* padding: 0 1.5rem; */
  /* border-bottom: 1px solid #eee; */
  background-color: #fff;
  font-size: 2.5rem;
`;

const SuccessIcon = styled.div`
  background-color: rgb(223, 255, 109);
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  /* margin: 1rem auto; */
  margin-right: 1rem;
  position: absolute;
  bottom: 12px;
  left: 14px;
  svg path {
    stroke: #000 !important;
  }
  svg {
    font-size: 0.8rem;
  }
`;

const Basket = styled.div`
  @media screen and (max-width: ${theme.breakpoints.small}px) {
    padding-left: 1rem;
    /* margin-right: 1rem;
    svg {
      height: 2.6rem;
    }
    svg path {
      // stroke: ${theme.light.colors.purple};
      stroke-width: 4px;
    } */
  }
`;

const Search = styled.div`
  @media screen and (max-width: ${theme.breakpoints.small}px) {
    margin-right: 1rem;
    svg path {
      stroke: ${theme.light.colors.purple};
      stroke-width: 4px;
    }
  }
`;

export default () => {
  const setSideMenuOpen = UiStore.useStoreActions(
    (actions) => actions.setSideMenuOpen
  );

  const cookieMobileAppPopup = UiStore.useStoreState(
    (state) => state.cookieMobileApp
  );

  const loggedIn = AuthStore.useStoreState((state) => state.isLoggedIn);
  const localStore = storageFactory(() => localStorage);

  const member = AuthStore.useStoreState((state) => state.member);
  const birthdayReminder = Cookie.get('birthdayReminder');
  const marketingStore = UiStore.useStoreState(
    (state) => state.cookieMarketing
  );

  const scrollShadow = document.getElementById('addShadowJs');
  useEffect(() => {
    const detectScroll = (event: any) => {
      const getScroll = event.currentTarget.scrollY;
      // if (scrollShadow) {
      if (getScroll > 40) {
        scrollShadow.style.boxShadow = '0px 1px 9px 0px rgba(0, 0, 0, 0.1)';
      } else {
        scrollShadow.style.boxShadow = '0px 1px 9px 0px rgba(0, 0, 0, 0.1)';
      }
      // }
    };

    window.addEventListener('scroll', detectScroll);
    return () => {
      window.removeEventListener('scroll', detectScroll);
    };
  }, [!!scrollShadow]);

  const getBirthdayReminder = () => {
    if (member) {
      if (!member.birthDate) {
        if (!!birthdayReminder) {
          const [timestamp] = timestampAndCount(birthdayReminder);
          if (dateDiff(timestamp) >= 10) {
            BirthdayReminderModal({});
          }
        } else {
          createCookieBirtdayReminder();
        }
      }
    }
  };

  // const isLoggedIn =
  //   loggedIn || !!localStore.getItem('isLoggedIn') ? true : false;

  // if (!loggedIn) return <AnonymousHeader />;
  // if (!!localStore.getItem('isLoggedIn') === false) {
  //   return <AnonymousHeader />;
  // } else if (!!localStore.getItem('isLoggedIn') === false && !loggedIn) {
  //   return <AnonymousHeader />;
  // }

  if (loggedIn) {
    if (Cookie.get('RgpdBanner') && marketingStore) {
      getBirthdayReminder();
    }
  }

  const isLoggedIn = AuthStore.useStoreState((state) => state.isLoggedIn);

  const menuDevice: DeviceEnum = isMobile
    ? DeviceEnum.MOBILE
    : DeviceEnum.DESKTOP;
  useQuery<getHeaderNavigation>(headerNavigationQuery, {
    variables: { device: menuDevice, os: OsEnum.SITE },
  });
  return (
    <>
      <>
        {cookieMobileAppPopup && (isAndroid || isIOS) && (
          <BannerApp android={isAndroid} />
        )}
        <FixBar id="addShadowJs">
          <TopBar>
            <HeaderMobileContainer id="headermobile">
              <HeaderNavContainer>
                <HeaderLogoContainer>
                  <a href="/">
                    <LogoTitle>Bazarchic</LogoTitle>
                  </a>
                </HeaderLogoContainer>
                <HeaderMenuContainer>
                  <div
                    style={{ position: 'relative' }}
                    onClick={() => {
                      setSideMenuOpen(true);
                    }}
                  >
                    {isLoggedIn && (
                      <SuccessIcon>
                        <CheckMark />
                      </SuccessIcon>
                    )}
                    <AccountHeader width="20" height="20" />
                  </div>
                  <div>
                    <WishListMenu />
                  </div>
                  <Basket>
                    <HeaderBasket />
                  </Basket>
                </HeaderMenuContainer>
              </HeaderNavContainer>
            </HeaderMobileContainer>
          </TopBar>
        </FixBar>
      </>
    </>
  );
};
